module.exports = __webpack_public_path__ + "assets/img/tel.cfefda5a.png";